import { AUTH_ROUTE_PATHS } from "./authRouteConfig";
import { getInitializedUserManager } from "./oidcManagerService";

// oidc-client's silent-renew iframe loads redirect_uri (/auth/callback), which
// would otherwise boot the whole SPA inside the frame: its callback route would
// consume the state the parent is waiting on and, on failure, clear the shared
// localStorage. Detect the frame before React mounts and only hand the URL back
// (signinSilentCallback). Not provider-gated: oidc-client falls back to this
// frame whenever the stored user has no refresh token, under either provider
// (ForgeRock returns its response in the query string, Entra in the fragment).
const hasAuthorizationResponse = () => {
  const { hash = "", search = "" } = globalThis.location ?? {};

  return [
    new URLSearchParams(hash.replace(/^#/, "")),
    new URLSearchParams(search),
  ].some((params) => params.get("code") || params.get("error"));
};

export const isSilentRenewFrame = () => {
  // Not an iframe at all — the ordinary top-level sign-in.
  if (globalThis.self === globalThis.top) {
    return false;
  }

  if (globalThis.location?.pathname !== AUTH_ROUTE_PATHS.AUTH_CALLBACK) {
    return false;
  }

  return hasAuthorizationResponse();
};

export const completeSilentRenewFrame = async () => {
  try {
    const userManager = await getInitializedUserManager();
    await userManager.signinSilentCallback();
  } catch (error) {
    // Nothing to recover: no app is running in this frame and there is no user
    // to tell. The parent's signinSilent falls over on its own timeout, and
    // renewToken already handles that rejection.
    console.error("Silent renew frame could not notify its parent.", error);
  }
};
